module.exports = __webpack_public_path__ + "static/media/workPvcCeilings14.f12290f2.jpg";